import type { QuickSuggestion } from '@/types/chatbot'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'products',
    labelKey: 'chatbot.suggestions.productsLabel',
    messageKey: 'chatbot.suggestions.productsMessage',
  },
  {
    id: 'sectors',
    labelKey: 'chatbot.suggestions.sectorsLabel',
    messageKey: 'chatbot.suggestions.sectorsMessage',
  },

  {
    id: 'contacts',
    labelKey: 'chatbot.suggestions.contactsLabel',
    messageKey: 'chatbot.suggestions.contactsMessage',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 */
export const contactCTAs = [
  { id: 'phone', labelKey: 'chatbot.cta.phone', value: '+39 0375 889091' },
  { id: 'email', labelKey: 'chatbot.cta.email', value: 'infocom@selea.com' },
]
